import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../cart/services/store';
import Campaigns from './components/campaigns/Campaigns';
import SubmitIdea from './components/submit_idea/SubmitIdea';
import { campaignsActions } from './actions';

window.store = window.store || store;

document.addEventListener('DOMContentLoaded', () => {
  const elementId = 'react-campaigns-component';
  const data = JSON.parse(document.querySelector(`script[data-dom-id="${elementId}"]`).textContent);
  const { campaignsByCategory, categories } = data;
  window.store.dispatch(campaignsActions.setCategories(categories));
  window.store.dispatch(campaignsActions.setCampaignsByCategory(campaignsByCategory));

  ReactDOM.hydrate(
    <Provider store={window.store}>
      <Campaigns />
    </Provider>,
    document.getElementById(elementId),
  );

  const submitIdeaElement = document.getElementById('react-submit-idea');
  ReactDOM.render(
    <SubmitIdea />,
    submitIdeaElement,
  );

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  ReactDOM.render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
    document.getElementById('react-sticky-categories'),
  );
});
